import { React, useEffect } from "react";
import { useParams } from "react-router-dom";
import { blogPosts } from "./posts";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./BlogPost.css";
import UseInstagramEmbed from "./UseInstagramEmbed";
import {
  FaTwitter,
  FaFacebookF,
  FaWhatsapp,
  FaLinkedinIn,
  FaEnvelope,
} from "react-icons/fa";

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((post) => post.slug === slug);

  UseInstagramEmbed();

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.instagram.com/embed.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  if (!post) {
    return <div>Post not found!</div>;
  }

  // Share URLs
  const shareUrl = window.location.href;
  const shareText = encodeURIComponent(`${post.title} - ${post.excerpt}`);

  const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
    shareUrl
  )}&text=${shareText}`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    shareUrl
  )}`;
  const whatsappUrl = `https://api.whatsapp.com/send?text=${shareText}%20${encodeURIComponent(
    shareUrl
  )}`;
  const linkedInUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    shareUrl
  )}&title=${shareText}`;
  const emailUrl = `mailto:?subject=${encodeURIComponent(
    post.title
  )}&body=${shareText}%20${encodeURIComponent(shareUrl)}`;

  return (
    <div className="blog-post-container">
      <Helmet>
        <title>{post.title} | My Blog</title>
        <meta name="description" content={post.excerpt} />
        <meta property="og:title" content={post.title} />
        <meta property="og:description" content={post.excerpt} />
        <meta property="og:type" content="article" />
        {post.images?.[0] && (
          <meta property="og:image" content={post.images[0].src} />
        )}
      </Helmet>
      <h1 className="blog-post-title">{post.title}</h1>
      <h2 className="blog-post-excerpt">{post.excerpt}</h2>
      <p className="blog-post-date">
          {"Published: " + new Date(post.date).toLocaleDateString()}
        </p>
      <div className="blog-post-content">
        {post.content.split("\n").map((line, index) => (
          <p key={index}>{line}</p>
        ))}
        {post.images?.length > 0 && (
          <div className="blog-post-images">
            {post.images.map((img, index) => (
              <img
                key={index}
                src={img.src}
                alt={img.alt}
                className="blog-post-image"
              />
            ))}
          </div>
        )}
        {post.instagram && (
          <div className="instagram-embed-container">
            <div
              className="instagram-embed"
              dangerouslySetInnerHTML={{
                __html: `<blockquote class="instagram-media" data-instgrm-permalink="${post.instagram}" data-instgrm-version="14"></blockquote>`,
              }}
            />
            {post.instagramCaption && (
              <p className="instagram-caption">{post.instagramCaption}</p>
            )}
          </div>
        )}
        {post.youtube && (
          <div className="youtube-embed-container">
            <iframe
              width="100%"
              height="400"
              src={post.youtube}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}
      </div>

      {/* Share Buttons Section */}
      <div className="share-buttons-section">
        <h3 className="share-header">Share this post:</h3>
        <div className="share-buttons">
          <a
            href={twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-button twitter"
          >
            <FaTwitter size={24} />
          </a>
          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-button facebook"
          >
            <FaFacebookF size={24} />
          </a>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-button whatsapp"
          >
            <FaWhatsapp size={24} />
          </a>
          <a
            href={linkedInUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="share-button linkedin"
          >
            <FaLinkedinIn size={24} />
          </a>
          <a href={emailUrl} className="share-button email">
            <FaEnvelope size={24} />
          </a>
        </div>
      </div>

      <div className="back-to-blog-button">
        <Link to="/blog">
          <button>← Back to The Futsal Directory Blog Home</button>
        </Link>
      </div>
    </div>
  );
};

export default BlogPost;
